import GridCellWithId from './GridCellWithId';
import GridRowWithId from './GridRowWithId';

export const dataGridIdSlots = {
  row: GridRowWithId,
  cell: GridCellWithId
};
